import { CopyAll, ListAlt, Scanner, StorageRounded } from '@mui/icons-material';
import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const CatalogAddProducts = () => {
  const navigate = useNavigate();

  return (
    <>
      <Stack direction="row" justifyContent="space-between">
        <Box width={100} />
        <Typography variant="h4">Add Products to this catalog</Typography>
        <Button
          onClick={() => navigate('..', { relative: 'path' })}
          sx={{ mr: 2, alignSelf: 'flex-end' }}
        >
          Cancel
        </Button>
      </Stack>
      <Stack direction="row" justifyContent="space-around" mt={2}>
        <Card sx={{ m: 2, flex: '1 1 0', textAlign: 'center' }}>
          <CardContent>
            <ListAlt sx={{ width: 64, height: 64, color: 'primary.main' }} />
            <Typography fontWeight={700}>From a File</Typography>
            <Typography textAlign="left">
              Upload any .CSV, .XLS, .XLSX or XML spreadsheets with the product
              name and price.
            </Typography>
            <Button variant="flat" onClick={() => navigate('./spreadsheet')}>
              Start An Import
            </Button>
          </CardContent>
        </Card>
        <Card sx={{ m: 2, flex: '1 1 0', textAlign: 'center' }}>
          <CardContent>
            <Scanner sx={{ width: 64, height: 64, color: 'primary.main' }} />
            <Typography fontWeight={700}>Create a list</Typography>
            <Typography textAlign="left">
              You can manually create a list by copying/pasting the data or
              using an Barcode Scanner.
            </Typography>
            <Button variant="flat" onClick={() => navigate('./list')}>
              Start A List
            </Button>
          </CardContent>
        </Card>
        <Card sx={{ m: 2, flex: '1 1 0', textAlign: 'center' }}>
          <CardContent>
            <StorageRounded
              sx={{ width: 64, height: 64, color: 'primary.main' }}
            />
            <Typography fontWeight={700}>From Database</Typography>
            <Typography textAlign="left">
              Use our database of products to add products to this catalog.
            </Typography>
            <Button variant="flat" onClick={() => navigate('./database')}>
              Start Adding Products
            </Button>
          </CardContent>
        </Card>
        <Card sx={{ m: 2, flex: '1 1 0', textAlign: 'center' }}>
          <CardContent>
            <CopyAll sx={{ width: 64, height: 64, color: 'primary.main' }} />
            <Typography fontWeight={700}>From Existing Catalog</Typography>
            <Typography textAlign="left">
              Copy the products from an existing catalog to this catalog.
            </Typography>
            <Button variant="flat" onClick={() => navigate('./copy')}>
              Start From A Catalog
            </Button>
          </CardContent>
        </Card>
      </Stack>
    </>
  );
};

export default CatalogAddProducts;
